import { useGetAllFeatureFlagQuery } from '../features/featureFlag/featureFlagApi';
import { DEVICE_COUNT_TOGGLE_FEATURE_FLAG } from '../constants';
import { FeatureFlagData } from '../types';

export const useDeviceCountToggleFlag = (
    enabled = true
): { isDeviceCountToggleEnabled: boolean; isFlagLoading: boolean } => {
    const { data: featureFlags, isLoading } = useGetAllFeatureFlagQuery({}, { skip: !enabled });
    const flag = featureFlags?.data?.find(
        (f: FeatureFlagData) => f.featureFlagName === DEVICE_COUNT_TOGGLE_FEATURE_FLAG
    );
    return { isDeviceCountToggleEnabled: Boolean(flag?.enabled), isFlagLoading: isLoading };
};
